import { useEffect, useState, type ReactNode } from 'react';
import { useUser } from '@clerk/clerk-react';
import { ShieldAlert, Mail } from 'lucide-react';
import { fetchUserProfile } from '../lib/api';

/**
 * SignedIn kullanıcı yasaklanmışsa (profiles.is_banned = true) tüm uygulama
 * arayüzünü (sidebar dahil) render etmeden tam ekran engel mesajı gösterir.
 */
export function BanGate({ children }: { children: ReactNode }) {
  const { user, isLoaded } = useUser();
  const [checked, setChecked] = useState(false);
  const [isBanned, setIsBanned] = useState(false);

  useEffect(() => {
    if (!isLoaded || !user) {
      setChecked(true);
      return;
    }

    let isMounted = true;

    async function checkBanStatus() {
      try {
        const profile = await fetchUserProfile(user!.id);
        if (isMounted) setIsBanned(Boolean(profile?.is_banned));
      } catch (err) {
        console.error('Yasaklı kullanıcı kontrolü başarısız:', err);
      } finally {
        if (isMounted) setChecked(true);
      }
    }

    checkBanStatus();

    return () => {
      isMounted = false;
    };
  }, [user, isLoaded]);

  if (!isLoaded || !checked) {
    return <div className="soru-loading min-h-screen">Yetki doğrulanıyor...</div>;
  }

  if (isBanned) {
    return (
      <div className="fixed inset-0 z-[100] bg-white dark:bg-slate-950 flex flex-col items-center justify-center text-center p-6">
        <div className="soru-card max-w-md w-full p-8 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 space-y-4 shadow-xl">
          <div className="w-16 h-16 bg-indigo-50 dark:bg-indigo-950/40 text-indigo-600 dark:text-indigo-400 rounded-2xl flex items-center justify-center mx-auto">
            <ShieldAlert size={32} strokeWidth={2.5} />
          </div>
          <h2 className="text-xl md:text-2xl font-black text-slate-900 dark:text-white">
            Hesabınız Yasaklanmıştır
          </h2>
          <p className="text-xs md:text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
            Bitmiyo topluluk kurallarını ihlal ettiğiniz için erişiminiz kısıtlanmıştır.
          </p>
          <div className="pt-2">
            <a
              href="mailto:bilgi@bitmiyo.com.tr"
              className="soru-btn soru-btn-primary px-6 py-2.5 text-xs w-full shadow-md"
            >
              <Mail size={15} /> Destek ile İletişime Geç
            </a>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
